module.exports = __webpack_public_path__ + "static/media/logo_lg.9f834471.png";